import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, TOKENS } from '../context/ThemeContext';
import { supabase } from '../supabase';
import SEO from '../components/SEO';

function Login() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const c = TOKENS[theme];

  useEffect(() => {
    // Check if user is already logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate('/');
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) navigate('/');
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  const handleGoogleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin
      }
    });
  };

  return (
    <div style={{
      background: c.bg,
      minHeight: '100vh',
      color: c.text,
      fontFamily: "'Inter', -apple-system, sans-serif",
      transition: 'background 0.25s, color 0.25s',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <SEO
        title="Log in"
        description="Sign in to TrailCode to track your Salesforce coding progress and compete on the leaderboard."
        url="https://trailcode.org/login"
        noIndex={true}
      />
      {/* Navbar */}
      <nav style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 clamp(24px, 6vw, 120px)',
        height: '58px',
        background: c.navBg,
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${c.border}`,
        position: 'sticky',
        top: 0,
        zIndex: 100,
        transition: 'background 0.25s, border-color 0.25s',
      }}>
        <div 
          onClick={() => navigate('/')}
          style={{
            fontSize: '20px',
            fontWeight: 800,
            letterSpacing: '-0.5px',
            color: c.text,
            cursor: 'pointer',
          }}>
          Trail<span style={{ color: c.accent }}>Code</span>
        </div>
      </nav>

      {/* Hero - Centered */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
        textAlign: 'center',
      }}>
        <h1 style={{
          fontSize: 'clamp(32px, 5vw, 48px)',
          fontWeight: 800,
          marginBottom: '16px',
          lineHeight: 1.2,
          letterSpacing: '-1px',
        }}>
          Welcome to <span style={{ color: c.accent }}>TrailCode</span>
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: c.secondary,
          marginBottom: '40px',
          lineHeight: 1.6,
          maxWidth: '480px',
        }}>
          Sign in to track your progress and compete on the leaderboard
        </p>
        
        <button 
          onClick={handleGoogleLogin}
          style={{
            background: c.accent,
            color: theme === 'dark' ? c.bg : '#fff',
            border: 'none',
            padding: '13px 32px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: 600,
            fontFamily: "'Inter', sans-serif",
            transition: 'opacity 0.15s, transform 0.12s',
            boxShadow: theme === 'dark' ? `0 0 24px rgba(79,142,247,0.25)` : `0 2px 12px rgba(45,111,240,0.3)`,
          }}
          onMouseEnter={e => { e.target.style.opacity = '0.88'; e.target.style.transform = 'translateY(-1px)'; }}
          onMouseLeave={e => { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; }}>
          🔵 Continue with Google
        </button>
      </div>
    </div>
  );
}

export default Login;